import { makeStyles } from '@material-ui/core/styles'

const datagridStyles = makeStyles({
    headerCell: {
        fontWeight: 700
    }
})

export default datagridStyles
